import axios from "axios";
import {getBaseHost} from "../utils/url/url";
import {APIUrls} from "../utils/appServer/appServer";
import { consoleLogError } from "../utils/console";

export const getVersionRequest = async () => {
  let url = getBaseHost() + APIUrls.status + "?t=" + Date.now();
  try {
    const res = await axios.get(url);
    return res?.data?.version;
  } catch (e) {
    return undefined;
  }
};

// - if refresh token is available, then the user refreshed token will be returned for this request.
// - if no refresh token, then an anonymous token will be returned for this request.
export const refreshTokenRequest = (refreshToken = "") => {
  let tokenLink = getBaseHost() + APIUrls.getToken;

  if (refreshToken) {
    tokenLink += "?token=" + refreshToken;
  }

  return axios
    .get(tokenLink)
    .then((response) => {
      const { access_token, refresh_token, expires_in } = response.data;
      const refreshTokenNew = refresh_token || refreshToken;

      return { accessToken: access_token, refreshToken: refreshTokenNew, expiresIn: expires_in };
    })
    .catch((error) => {
      consoleLogError("Refresh Token", "Error refreshing token: ", { refreshToken, error });
      return null;
    });
};
